import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './../assets/css/pages/modal.css';
import { LoaderMedium } from '../components/loader';
import MasterForm  from '../components/form/master';

function ModalMaster(props) {
    // console.log(props)
    return (
      <> 
        <Modal dialogClassName="modal-70w modal-dialog-scrollable" show={props.isShow||false} onHide={(e) => props._toggleModal(e, false)} size="md" className="mod-custom team-detail" backdrop="static">
            {props._isProcess[props._formData[0]?.form_type]
            ?
                <Modal.Header>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
            :
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
            }
            <Modal.Body>
                {props.loader 
                ?
                    <div className="text-center mt-5 mb-5">
                        <LoaderMedium size={45} />
                    </div>
                :
                    <>
                        <MasterForm
                            formType={props.formType}
                            data={props.data}
                            _errorData={props._errorData}
                            _isProcess={props._isProcess}
                            // _isBtnDisabled={{...isBtnDisabled}}
                            _updateInput= {(form_type, variable_type, input_type, field, value) => props._updateInput(form_type, variable_type, input_type, field, value)}
                            _submitForm={(e, form_type) => props._submitForm(e, form_type)}
                            _formData={props._formData}
                            selectOptions={props.selectOptions}
                            buttonText={props?.buttonText || {}}
                            userRoleIds={props?.userRoleIds || []}
                            noticeWarnings={props?.noticeWarnings || []}
                        />
                    </>
                }
            </Modal.Body>
            <Modal.Footer className="team-detail">
                <button className="btn btn-secondary" disabled={props.isProcess} onClick={(e) => props._toggleModal(e, false)}>Close</button>
            </Modal.Footer>
        </Modal>
      </>
    );
}
  
export default ModalMaster;